import { IGetAllEquipamentoMedicaoHistoricoUseCase } from "../../../presentation/useCases/read/get_all_equipamento_medicao_historico_use_case";
import { EquipamentoMedicaoHistorico } from "../../../../../common/domain/models/equipamento_medicao_historico";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * GetAllEquipamentoMedicaoHistoricoUseCase
 */

export class GetAllEquipamentoMedicaoHistoricoUseCase implements IGetAllEquipamentoMedicaoHistoricoUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async getAllEquipamentoMedicaoHistorico(
    idEquipamentoMedicao: number,
  ): Promise<EquipamentoMedicaoHistorico[]> {
    return await this.repository.getAllEquipamentoMedicaoHistorico(idEquipamentoMedicao);
  }
}
